import {crossfade} from 'svelte/transition';
import {quintOut} from 'svelte/easing';

const animDuration = 250;

export const [popInAnim, popOutAnim] = crossfade({
    fallback(node,) {
        const style = getComputedStyle(node);
        const transform = style.transform === 'none' ? '' : style.transform;

        return {
            duration: animDuration,
            easing: quintOut,
            css: (t) => `transform: ${transform} scale(${t / 20 + 0.95}); opacity: ${t};`
        }
    }
});